import React from 'react';
import { FaCogs, FaPrint, FaCut, FaBoxOpen, FaQuestionCircle, FaClock } from 'react-icons/fa';
import StatusBadge from './StatusBadge';

const OrdersTable = ({
  selectAllRef,
  headerCountLabel,
  onSelectAll,
  groupedByOrder,
  selectedPositionIds,
  onToggleOrderGroup,
}) => {
  return (
    <table className="table table-striped align-middle">
      <thead>
        <tr>
          <th>
            <input
              ref={selectAllRef}
              type="checkbox"
              className="form-check-input"
              onChange={onSelectAll}
            />
            <span className="ms-2">{headerCountLabel}</span>
          </th>
          <th>Заказ / Отправление / Дата</th>
          <th>Позиции</th>
          <th>Артикулы</th>
          <th>Сумма</th>
        </tr>
      </thead>
      <tbody>
        {groupedByOrder.map((group, idx) => {
          const ids = group.positions.map(p => p.id);
          const all = ids.every(id => selectedPositionIds.includes(id));
          const some = !all && ids.some(id => selectedPositionIds.includes(id));
          const any = group.positions[0];
          const createdAt = new Date(any.createdAt);
          const orderExternalId = group.order?.externalId || any.order?.externalId;

          // уникальные статусы заказа
          const uniqueStatuses = Array.from(new Set(group.positions.map(p => p.status)));

          return (
            <tr key={`order-${group.orderId}-${idx}`}>
              <td>
                <input
                  type="checkbox"
                  className="form-check-input"
                  ref={el => {
                    if (el) el.indeterminate = some;
                  }}
                  checked={all}
                  onChange={() => onToggleOrderGroup(group)}
                />
                <span className="ms-2">
                  ({ids.filter(id => selectedPositionIds.includes(id)).length}/{ids.length})
                </span>
              </td>
              <td>
                <div>
                  <strong>{orderExternalId}</strong>
                  <br />
                  <small>{group.orderId}</small>
                  <br />
                  <small>{createdAt.toLocaleString()}</small>
                </div>

                {/* бейджи статусов */}
                <div className="mt-2 d-flex flex-wrap gap-1">
                  {uniqueStatuses.map(status => {
                    return (
                      <div className="mt-2">
                        <StatusBadge status={status} />
                      </div>
                    );
                  })}
                </div>
              </td>
              <td>
                {group.positions.slice(0, 3).map(p => (
                  <img
                    key={p.id}
                    src={p.image}
                    alt={p.article}
                    style={{ width: 40, height: 40, objectFit: 'contain', marginRight: 4 }}
                  />
                ))}
                {group.positions.length > 3 && (
                  <span>+{group.positions.length - 3}</span>
                )}
              </td>
              <td>{group.positions.map(p => p.article).join(', ')}</td>
              <td>
                {(
                  group.positions.reduce((sum, p) => sum + (p.convertedPrice || 0), 0) / 100
                ).toFixed(2)}{' '}
                ₽
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default OrdersTable;
